import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { filterSelfReferencingResources } from 'containers/TopicCenter/utils';
import ListItem from './ListItem';

const GroupedLists = ({
  assessment,
  data,
  isFullWidth,
  topic,
  entryId,
  clientExclusiveAsResource,
  labelValue,
}) => {
  const altHeader = _get(
    assessment,
    'fields.globalOptions.groupedListsAltHeader',
  );

  const topicTitle = _get(topic, 'fields.title');
  const topicSlug = _get(topic, 'fields.slug');

  if (!data.length) return null;

  return data.map((list, i) => (
    <React.Fragment key={_get(list, 'item.sys.id')}>
      {i === 1 && altHeader && (
        <Grid item xs={12}>
          <Typography color="textPrimary" variant="h4">
            {altHeader}
          </Typography>
        </Grid>
      )}
      <ListItem
        item={list.item}
        resources={filterSelfReferencingResources(list.resources)}
        assessmentName={_get(assessment, 'fields.name')}
        topicTitle={topicTitle}
        topicSlug={topicSlug}
        isFullWidth={isFullWidth}
        entryId={entryId}
        clientExclusiveAsResource={clientExclusiveAsResource}
        labelValue={labelValue}
      />
    </React.Fragment>
  ));
};

GroupedLists.propTypes = {
  data: PropTypes.array,
  topic: PropTypes.object,
  isFullWidth: PropTypes.bool,
  labelValue: PropTypes.string,
};

export default GroupedLists;
